import whopImg from "@/assets/case-studies/whop.jpg";
import c23Img from "@/assets/case-studies/c23.png";
import empireImg from "@/assets/case-studies/empire.jpg";
import hummingImg from "@/assets/case-studies/humming.png";
import merImg from "@/assets/case-studies/mer.jpg";
import chillImg from "@/assets/case-studies/chill.jpg";
import exceptionalImg from "@/assets/case-studies/exceptional.jpg";

import whopLogo from "@/assets/case-studies/whop-logo.svg";
import c23Logo from "@/assets/case-studies/c23-logo.svg";
import empireLogo from "@/assets/case-studies/empire-logo.png";
import hummingLogo from "@/assets/case-studies/humming-logo.svg";
import merLogo from "@/assets/case-studies/mer-logo.svg";
import chillLogo from "@/assets/case-studies/chill-logo.svg";
import exceptionalLogo from "@/assets/case-studies/exceptional-logo.png";

import svcWebDesignLight from "@/assets/services/web-design-light.svg";
import svcWebDesignDark from "@/assets/services/web-design-dark.svg";
import svcEcommerceLight from "@/assets/services/framer-ecommerce-light.svg";
import svcEcommerceDark from "@/assets/services/framer-ecommerce-dark.svg";
import svcWebsiteFixLight from "@/assets/services/website-fix-light.svg";
import svcWebsiteFixDark from "@/assets/services/website-fix-dark.svg";
import svcEmailMarketingLight from "@/assets/services/email-marketing-light.svg";
import svcEmailMarketingDark from "@/assets/services/email-marketing-dark.svg";
import svcAssessmentLight from "@/assets/services/assessment-light.svg";
import svcAssessmentDark from "@/assets/services/assessment-dark.svg";

export interface CaseStudy {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  image: string;
  logo: string;
  url?: string;
}

export const caseStudies: CaseStudy[] = [
  {
    id: "whop",
    title: "Whop HigherEd",
    subtitle: "Building Entrepreneurs",
    category: "Framer Web Dev",
    image: whopImg,
    logo: whopLogo,
  },
  {
    id: "c23",
    title: "c23 Labs",
    subtitle: "Private Tattoo Mentorship",
    category: "Framer Web Dev",
    image: c23Img,
    logo: c23Logo,
  },
  {
    id: "empire",
    title: "EMPIRE",
    subtitle: "Independent Record Label",
    category: "Framer Commerce Web Dev",
    image: empireImg,
    logo: empireLogo,
  },
  {
    id: "humming",
    title: "Humming.ai",
    subtitle: "Premium Ad Services",
    category: "Framer Web Dev",
    image: hummingImg,
    logo: hummingLogo,
  },
  {
    id: "mer",
    title: "MĒR",
    subtitle: "Food & Beverage",
    category: "Framer Template Development",
    image: merImg,
    logo: merLogo,
  },
  {
    id: "chill",
    title: "Chill Bites & Drinks",
    subtitle: "Beverage Brand",
    category: "Framer Web Dev + Branding",
    image: chillImg,
    logo: chillLogo,
  },
  {
    id: "exceptional",
    title: "Exceptional 100",
    subtitle: "Annual Publication",
    category: "Framer Site Development",
    image: exceptionalImg,
    logo: exceptionalLogo,
  },
];

export interface Service {
  title: string;
  description: string;
  pricing: string;
  details?: string[];
  image: string;
  imageDark?: string;
}

export const services: Service[] = [
  {
    title: "Framer Website Design & Development",
    description: "Full-service website design and development on Framer",
    pricing: "Contact for Pricing",
    image: svcWebDesignLight,
    imageDark: svcWebDesignDark,
    details: [
      "Custom design tailored to your brand",
      "Responsive across all devices",
      "CMS integration for easy content updates",
      "SEO-optimized structure",
      "Analytics & performance tracking setup",
    ],
  },
  {
    title: "Framer E-Commerce Development",
    description: "E-commerce solutions built on Framer",
    pricing: "Contact for Pricing",
    image: svcEcommerceLight,
    imageDark: svcEcommerceDark,
    details: [
      "Product catalog & collections",
      "Cart & checkout integration",
      "Synced inventory management",
      "Shopify backend architecture review",
    ],
  },
  {
    title: "Framer Website Fix",
    description: "Quick fixes and updates for existing Framer sites",
    pricing: "Contact for Pricing",
    image: svcWebsiteFixLight,
    imageDark: svcWebsiteFixDark,
    details: [
      "Bug fixes & troubleshooting",
      "Performance optimization",
      "Content updates & adjustments",
    ],
  },
  {
    title: "Email Marketing Design · Klaviyo",
    description: "Strategic email design and Klaviyo integration",
    pricing: "Starting at $1,200/mo",
    image: svcEmailMarketingLight,
    imageDark: svcEmailMarketingDark,
    details: [
      "Custom email template design",
      "Klaviyo flow setup & automation",
      "Campaign strategy & calendar",
      "A/B testing & performance tracking",
    ],
  },
  {
    title: "Website Design Assessment",
    description: "Comprehensive audit and improvement plan",
    pricing: "Contact for Pricing",
    image: svcAssessmentLight,
    imageDark: svcAssessmentDark,
    details: [
      "UX/UI audit & heuristic evaluation",
      "Performance & accessibility review",
      "Actionable improvement roadmap",
      "Competitor benchmarking",
    ],
  },
];

export interface Testimonial {
  name: string;
  company: string;
  text: string;
  date: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Alli Minetti Labs",
    company: "Contra Labs",
    text: "Great collaboration with Madison! Great experience with reliable communication, fast iteration, and implementing feedback quickly.",
    date: "Feb 2026",
  },
  {
    name: "Elaina Olson",
    company: "Looped.IN",
    text: "Excellent work, great communication, and nice to work with!",
    date: "Nov 2025",
  },
  {
    name: "Melissa Aurigemma",
    company: "Exceptional Capital",
    text: "Madison is amazing! Second year working on an annual project with her and she executed perfectly.",
    date: "Sep 2025",
  },
  {
    name: "Jasmine Lee",
    company: "Base",
    text: "Madison was phenomenal to work with - great at her job, eager to hop in and suggest changes, responsive and a great communicator.",
    date: "Aug 2024",
  },
  {
    name: "Oscar Akermo",
    company: "",
    text: "Madison is as flexible as she is thorough. Her taste and knowledge in what looks good is impeccable.",
    date: "Dec 2024",
  },
  {
    name: "Mary Petrino",
    company: "Whop",
    text: "Madison is lovely to work with! She meets prompt deadlines and is extremely timely with any Framer request that I have.",
    date: "Jan 2025",
  },
];
